import { FC } from 'react';
import SlideAnimator, { FrameRenderer } from '../common/SlideAnimator';

const TransactionSlideAnimator: FC<{ frames: FrameRenderer[] }> = ({
    frames,
}) => (
    <SlideAnimator
        rounded="md"
        shadow="md"
        w="full"
        h="full"
        // Making sure we can display at least two linked bank accounts without scrolling
        minH="510px"
        bg="white"
        frames={frames}
    />
);

export default TransactionSlideAnimator;
